import useSWR from 'swr';
import { fetcher } from 'utils/axios';
import { BASE_URL } from 'utils/baseUrlProvider';

// ==============================|| HOOK: usePatientInsurance ||============================== //
// Fetches the active insurance policy for a patient.
// Uses SWR for caching — the same patient's insurance is fetched ONCE and served instantly on repeat calls.

const usePatientInsurance = (patientId) => {
  // If no patient is selected, key is null → SWR does nothing
  const key = patientId
    ? `${BASE_URL}/insurance/patient-policies/?patient=${patientId}&is_active=true`
    : null;

  const { data, isLoading, error } = useSWR(key, fetcher, {
    revalidateOnFocus: false,   // Don't re-fetch when user switches browser tabs
    revalidateIfStale: false,   // Don't re-fetch automatically in background
    shouldRetryOnError: false,  // Don't show errors if insurance endpoint fails
  });

  const policies = data?.results || [];
  const activeInsurance = policies.length > 0 ? policies[0] : null;

  return {
    activeInsurance,        // The first active insurance policy object (or null)
    allPolicies: policies,  // All active policies for this patient
    insuranceLoading: isLoading,
    insuranceError: error,
  };
};

export default usePatientInsurance;
